/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CHART : LINE STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library))
export default theme => ({
	linechart: {
		width: '100%',
		'&.hasDetails-true': {
			cursor: 'pointer'
		},
		'& .data': {
			width: '100%',
			display: 'flex',
		    flexDirection: 'column',
		    // justifyContent: 'space-between',
			'& .info': {
				// borderBottom: '1px solid red', // for testing purposes to see where chart meets bottom of title text
				height: pxToEm(95),
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				padding: replacePXinStringWithEM(`16px 22px 0px`),
				'& .label': {
					marginBottom: pxToEm(-7)
				},
				'& .value': {
					extend: theme.typography.size.xxxlarge
				},
				'& .loading':{
					fontSize: pxToEm(16),
					marginTop: pxToEm(16)
				}
			},
			'& .visualization': {
				height: pxToEm(150), // make sure parent container have a defined height when using responsive component,
				width: '100%',
				// maxWidth: pxToEm(1000),
				position: 'relative'
			},
			transition: 'filter .2s ease-in 0s',
			'&:hover': {
				filter: 'brightness(98%)'
			}
		},
		'& .details': {
			textAlign: 'right',
			paddingTop: pxToEm(16)
		},
        // ------- loading state ----------//
        '& .loading':{
            '& .name-loader':{
                height: pxToEm(16),
                width: pxToEm(16),
                paddingBottom: pxToEm(20),
                '& div':{
                    borderColor: `${theme.color.primary.medium.swatch} transparent transparent transparent`,
                    borderWidth: pxToEm(2),
                    height: pxToEm(16),
                    width: pxToEm(16)
                }
            }
        }
	}
});